export const ROLES = {
    ADMIN: 1,
    WASTECO: 2,
    DISPOSER: 3,
    ACCOUNT: 4,
    ESS: 5,
    REGADMIN: 6,
    SUPPORTTEAM: 7,
    OPERATOR: 8,
    PURCHASING: 9
  };
  